<template>
  <div class="word-pop flexCenter" v-if="visible">
    <div class="word-pop-content">
      <div class="close-btn">
        <img src="@/assets/alert_close.png" @click.stop="visible = false" />
      </div>
      <div v-show="activeTab === 'video'" class="video-container">
        <video
          v-if="videoInfo"
          style="width:100%;height:100%;outline:none;object-fit: contain;"
          :loop="true"
          :src="videoInfo.url"
          :poster="videoInfo.poster"
          controls
          autoplay
          ref="videoPlayer"
        />
      </div>
      <div v-show="activeTab === 'board'" class="canvas-container">
        <word-mark v-if="boardInfo" :poster="boardInfo.poster"></word-mark>
      </div>
      <div class="tabs-container">
        <div
          class="tabs-item"
          :class="{ active: activeTab === 'video' }"
          @click="activeTab = 'video'"
        >
          <div class="tabs-item-cover">
            <img v-if="videoInfo" :src="videoInfo.poster" />
            <div class="tabs-item-play-icon">
              <img src="@/assets/icon-video-play.png" />
            </div>
          </div>
          <div v-if="videoInfo" class="tabs-item-text">
            {{ videoInfo.title }}
          </div>
        </div>
        <div
          class="tabs-item"
          :class="{ active: activeTab === 'board' }"
          @click="activeTab = 'board'"
        >
          <div class="tabs-item-cover">
            <img v-if="boardInfo" :src="boardInfo.poster" />
          </div>
          <div v-if="boardInfo" class="tabs-item-text">
            {{ boardInfo.title }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import WordMark from "./WordMark.vue";
export default {
  name: "WordPopNew",
  props: {},
  components: {
    WordMark,
  },
  data() {
    return {
      visible: false,
      videoInfo: null,
      boardInfo: null,
      activeTab: "board",
    };
  },
  methods: {
    show(data, tab = null) {
      this.videoInfo = data.videoInfo || null;
      this.boardInfo = data.boardInfo || null;
      if (tab) {
        this.activeTab = tab;
      }
      this.visible = true;
    },
  },
  watch: {
    activeTab(newVal) {
      if (this.$refs.videoPlayer) {
        if (newVal === "board") {
          this.$refs.videoPlayer.pause();
        } else {
          this.$refs.videoPlayer.play();
        }
      }
    },
  },
};
</script>

<style scoped>
.word-pop {
  position: fixed;
  z-index: 999999;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
}

.word-pop-content {
  position: relative;
}

.close-btn {
  width: 3rem;
  height: 3rem;
  position: absolute;
  top: 0rem;
  right: -5rem;
  cursor: pointer;
  z-index: 100;
}

.close-btn img {
  width: 100%;
  height: 100%;
}

.tabs-container {
  position: absolute;
  bottom: 0;
  right: -6.62rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

.tabs-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.tabs-item-cover {
  width: 4.62rem;
  height: 4.62rem;
  border-radius: 0.62rem 0.62rem 0.62rem 0.62rem;
  border: 0.15rem solid #ceeeff;
  background: #eeeeee;
  position: relative;
  overflow: hidden;
}

.tabs-item-cover img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.tabs-item-play-icon {
  width: 1.92rem;
  height: 1.92rem;
  border-radius: 0.15rem 0.15rem 0.15rem 0.15rem;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 50%;
}

.tabs-item-play-icon img {
  width: 100%;
  height: 100%;
}

.tabs-item-text {
  font-weight: 600;
  font-size: 0.92rem;
  color: #ffffff;
}

.tabs-item.active .tabs-item-cover {
  border-color: rgb(15, 133, 219);
}

.video-container {
  width: 60rem;
  height: 40rem;
  padding: 0.92rem;
  border-radius: 0.92rem 0.92rem 0.92rem 0.92rem;
  background: #ffffff;
  overflow: hidden;
  box-sizing: border-box;
}

.canvas-container {
  width: 60rem;
  height: 40rem;
  background: #ffffff;
  border-radius: 0.92rem 0.92rem 0.92rem 0.92rem;
}
</style>
